
const baseHost = process.env.VUE_APP_HOST
//const baseHost = 'https://api.299of.com/'

import storage from '@/utils/common/storage.js'
import router from '../../router/index.js'
// 引入axios
import axios from 'axios';

// 创建axios实例
const httpService = axios.create({
    baseURL: baseHost,
    // 请求超时时间
    timeout: 9000 // 需自定义
});

import { Loading,MessageBox } from 'element-ui'

let loading
let needLoadingRequestCount = 0
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: 'Loading……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading() {
  loading.close()
}

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}


const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    loading.close()
  }
}

// request拦截器
httpService.interceptors.request.use(
    config => {
		if(config.config.showLoading){
			showFullScreenLoading()
		}
		const token = storage.getToken();
		config.data.token = token;
        return config;
    },
    error => {
        // 请求错误处理
        Promise.reject(error);
    }
)

// respone拦截器
httpService.interceptors.response.use(
    response => {

		if (response.config.config.showLoading) {
		    tryHideFullScreenLoading()
		}
        // 统一处理状态
        const res = response.data;
		switch (res.code){
			case 200:
				return res.data
			break;
			case 201:
				router.replace('/login?from='+router.app.$route.path)
				return Promise.reject({
				    status: res.code,
				    message: res.msg
				});
			break;
			case 400:

				MessageBox.alert(res.errDetail,res.msg, {
				  confirmButtonText: res.locale == 'en'?'Ok':'确定'
				});
				return Promise.reject({
				    status: res.code,
				    message: res.msg
				});
			break;
			default:
				MessageBox.alert('发生未知错误，可能是服务器繁忙或网络拥堵。An unknown error has occurred, possibly due to server busy or network congestion','未知错误 Unknown error', {
					confirmButtonText: 'OK'
				});

				return Promise.reject({
				    status: 500,
				    message: '未知错误'
				});
		}

    },
    // 处理处理
    error => {
		 tryHideFullScreenLoading()
         if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '错误请求';
                    break;
                case 401:
                    error.message = '未授权，请重新登录';
                    break;
                case 403:
                    error.message = '拒绝访问';
                    break;
                case 404:
                    error.message = '请求错误,未找到该资源';
                    break;
                case 405:
                    error.message = '请求方法未允许';
                    break;
                case 408:
                    error.message = '请求超时';
                    break;
                case 500:
                    error.message = '服务器端出错';
                    break;
                case 501:
                    error.message = '网络未实现';
                    break;
                case 502:
                    error.message = '网络错误';
                    break;
                case 503:
                    error.message = '服务不可用';
                    break;
                case 504:
                    error.message = '网络超时';
                    break;
                case 505:
                    error.message = 'http版本不支持该请求';
                    break;
                default:
                    error.message = `未知错误${error.response.status}`;
            }
        } else {
            error.message = "连接到服务器失败";
        }

        return Promise.reject(error);
    }
)

/*网络请求部分*/

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function post(url, params = {},showLoading) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params,
			config: { showLoading: true}

        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

export default {
    post
}
